import { SupplyOwnerMap } from '../../../ControlPane/PaneComponents/SupplyFilters/types'

/**
 * Formats a list of locations into a readable string with commas and 'or'
 * @param {string[]} locations - Array of location names
 * @returns {string} Formatted string like "Location 1, Location 2, or Location 3"
 */
export function formatLocationsList(locations: string[] | null | undefined, conjunction: 'and' | 'or' = 'or'): string {
  if (!locations || locations.length === 0) return ''
  if (locations.length === 1) return locations[0]
  if (locations.length === 2) return `${locations[0]} ${conjunction} ${locations[1]}`

  const lastLocation = locations[locations.length - 1]
  const firstLocations = locations.slice(0, -1)
  return `${firstLocations.join(', ')}, ${conjunction} ${lastLocation}`
}

export function findStoreNumberByProduct(
  supplyOwnerMap: SupplyOwnerMap | undefined,
  component: Gravitate.SupplyOptionPrice['components'][number],
  productName: string
): Set<string> {
  if (!supplyOwnerMap) return new Set()
  return new Set(
    supplyOwnerMap.definitions
      .filter((def) => def.product === productName && def.supply_owner_id === component.supply_owner_id)
      .map((def) => def.location_name)
  )
}
